import { CapoPlugin } from "/home/forge/release.oase-bw.de/releases/20261102114535/client/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];